<template>
  <div>
    <div id="cower" @click="codeHide()" v-show="cover"></div>
    <div class="tipBox" v-show="iscode">
      <h3>
        <img src="../assets/logo.png" />

      </h3>
      <p>明医智APP扫描二维码进行登录</p>
      <p style="padding-top: 20px;">
        <qriously :value="initQCode" :size="300" />
      </p>
      <h6><a href="#">没有账号？立即下载</a></h6>
    </div>
    <transition name="my-trans">
      <div class="helpBox" v-show="show">
        <img src="../assets/help.png" />
      </div>
    </transition>
    <div class="wheatBox" v-show="showBox">
      <h5>发起连麦的用户<span @click="codeHide()">关闭连麦</span></h5>
      <div class="peopleBox" style="position: absolute;z-index: 6;background: #FFFFFF;">
        <dl v-for="(value, index) in mseArr" @click="clickIt(value)">
          <dt><img class="headpic" :src="value.img" /><i v-if="value.operation == true"><img :src="chose" /></i><i
              v-if="value.operation == false"><img :src="nochose" /></i></dt>
          <dd>{{ value.userName }}</dd>
        </dl>
      </div>
      <div class="rrrr">

      </div>
      <!--<div id="id_test_video" style="width:100px; height:100px;background: pink;position: fixed;left: 50%;top: 50%;z-index: 0;">-->
      <!--<iframe  src="tests(2).html"></iframe>-->

      <!--<iframe id="childFrame"  src="../../static/tests(2).html" width="" height=""></iframe>-->
      <!--</div>-->
      <!--<div id="id_test_video" style="width:100%; height:100px;background: pink;"></div>-->
      <!--<video-player  class="video-player vjs-custom-skin"
		                     ref="videoPlayer"
		                     :playsinline="true"
		                     :options="playerOptions"
		                     @play="onPlayerPlay($event)"
		                     @pause="onPlayerPause($event)"
		      >
		      </video-player>-->

    </div>
    <div class="closeBox" v-show="closeLive">
      <p><img src="../assets/live_close.png" /></p>
      <h2>关闭直播</h2>
      <h3>请确认先关闭obs推流工具后，再关闭直播</h3>
      <h4>
        <router-link to="/openLive"><span @click="closeOnlive()">确认</span></router-link>
      </h4>
    </div>
    <div class="headers" style="position: relative;">
      <header>
        <div class="logo">
          <img src="../assets/logo.png" />
        </div>
        <ul>
          <li>
            <router-link to="/">产品介绍</router-link>
          </li>
          <!-- <li>
            <router-link to="/News">新闻动态</router-link>
          </li> -->
          <li>
            <router-link to="/aboutUs">关于我们</router-link>
          </li>
          <li>
            <router-link to="/introduce">团队介绍</router-link>
          </li>
          <li>
            <router-link to="/contact">联系我们</router-link>
          </li>
        </ul>
        <span class="scodes" style="min-width: 136px;" @click="codeShow(); headerShow(); openselect()"
          v-bind:style="{ fontSize: myfont }"><img v-show="header" style="margin-right: 10px;vertical-align: super;"
            :src="userimg" /><i v-bind:style="{ width: iwidth }"
            style="display: inline-block;margin: 0 2px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap">{{
              loginTxt }}</i><img v-show="header"
            style="position: absolute;right: 10px;border-radius: 0;width: 7px;height: 7px;top: 42px;"
            src="../assets/385616900272080137.png" /></span>
        <div class="personageBox" v-show="isLogin">
          <ul>
            <router-link to="/uploadLive">
              <li>上传视频</li>
            </router-link>
            <router-link to="/openLive">
              <li>发起直播</li>
            </router-link>
            <li @click="loginOut()">退出</li>
          </ul>
        </div>
      </header>
    </div>
    <aside>
      <div class="leftBox">
        <ul>
          <li>
            <router-link to="/uploadLive">上传视频</router-link>
          </li>
          <li>
            <router-link to="/openLive">发起直播</router-link>
          </li>
        </ul>
      </div>
      <div class="rightBox">
        <dl>
          <dt><img src="../assets/live_tips.png" /></dt>
          <dd>
            <p>
              明医智项目直播需要您提前配备OBS直播软件，支持chrome、IE9以上、Firefox等浏览器
            </p>
            <p>
              需要您提前准备好： 摄像头、麦克风
            </p>
          </dd>
        </dl>
        <ul>
          <li>
            <p>视频标题</p>
            <input readonly="readonly" type="text" v-model="title" />
          </li>
          <li>
            <p>直播时间</p>
            <input readonly="readonly" type="text" v-model="time1" />
          </li>
          <li>
            <p>主播</p>
            <input readonly="readonly" type="text" v-model="stuname" />
          </li>
          <li>
            <p>直播简介</p>
            <textarea readonly="readonly" type="text" v-model="text" /></textarea>
          </li>
          <li>
            <p>rtmp地址:</p>
            <input readonly="readonly" type="text" v-model="rtmpurl" />
            <span class="coye" v-clipboard:copy="rtmpurl" v-clipboard:success="onCopy"
              v-clipboard:error="onError">点击复制</span>
          </li>
          <li>
            <p>直播码</p>
            <input readonly="readonly" type="text" v-model="livecode" />
            <span class="coye" v-clipboard:copy="livecode" v-clipboard:success="onCopy"
              v-clipboard:error="onError">点击复制</span>
          </li>
          <li>
            <p>直播权限</p>
            <!--<span style="margin-right: 30px;"  @click="showLive();onlineOr()"><img src="../assets/microphone.png"/></span>-->
            <span style="margin-right: 30px;" @click="onlineOr()"><img :src="close" /></span>
            <span @click="closed()"><img :src="forbid" /></span>
          </li>
        </ul>
        <div style="padding: 30px 0;">
          <span class="openBt" @click="closeL()">关闭直播</span><i class="jiaocheng">直播教程</i>
        </div>
        <div class="fottors">
          <a style="font-size: 18px;color: #666666;" href="https://www.miitbeian.gov.cn">Copyright © 2020-06-12 eagle soar
            . All Rights Reserved. 京ICP备18010429号</a>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
//var childFrameObj = document.getElementById('childFrame');

//childFrameObj.contentWindow.paramFromParent = 'userId0007';
import chose from "../assets/zhengzailianmai.png";
import nochose from "../assets/weilianmai.png";
import close from "../assets/microphonea.png";
import open from "../assets/microphone.png";
import forbid from "../assets/microphone_dis.png";
import forbidOpen from "../assets/microphone_disa.png";
import qs from "qs";
import { videoPlayer } from "vue-video-player";
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      iscode: false,
      show: false,
      isLogin: false,
      loginTxt: "扫码登陆",
      header: false,
      myfont: "20px",
      iwidth: "90px",
      initQCode: "",
      code: "",
      urltime: "",
      token: "",
      userimg: "",
      cover: false,
      showBox: false,
      b: false,
      aaaaa: "",
      chose: chose,
      closeLive: false,
      close: close,
      forbid: forbid,
      forbidOpen: forbidOpen,
      open: false,
      nochose: nochose,
      playerUrl: "",
      userid: "",
      roomName: "",
      livecode: "",
      rtmpurl: "",
      title: "",
      time1: "",
      stuname: "",
      text: "",
      id: "",
      mseArr: []
    };
  },

  created: function () {
    this.getMsg();
    this.getData();
    this.headerShow();
    this.codeShow();
  },

  methods: {
    loginOut() {
      localStorage.clear();
      location.reload();
    },
    onPlayerPlay(player) {
      alert("play");
    },
    showIfirame() {
      this.connect();
      this.b = true;
    },
    onPlayerPause(player) {
      alert("pause");
    },
    closeOnlive() {
      let _this = this;
      let qs = require("qs");
      let data = qs.stringify({
        id: this.id
      });
      this.$http
        .post("live/CloseLive.do", data)
        .then(function (response) {
          console.log(response);
          if (response.status == 200) {
            _this.mseArr = [];
            localStorage.removeItem("rtmpurl");
            localStorage.removeItem("livecode");
            localStorage.removeItem("roomName");
            //_this.mseArr=response.data.data;
            //console.log(_this.mseArr);
            //alert('上传成功');
            //location.reload();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    codeShow() {
      if (typeof localStorage.username != "undefined") {
        console.log(this.loginTxt);
        this.loginTxt = localStorage.username;
        this.userimg = localStorage.userimg;
        if (this.loginTxt != "扫码登陆") {
          this.myfont = "14px";
          this.iwidth = "55px";
          this.header = true;
          this.iscode = false;
          this.show = false;
          clearInterval(this.urltime);
          return;
        } else {
          this.getCode();
          this.iwidth = "55px";
          this.isLogin = false;
          this.iscode = true;
          this.show = true;
          this.urltime = setInterval(() => {
            this.getLogin();
          }, 5000);
        }
      }
    },
    openselect() {
      if (this.loginTxt != "扫码登陆") {
        this.isLogin = !this.isLogin;
      } else {
        this.getCode();
        this.iwidth = "90px";
        this.isLogin = false;
        this.iscode = true;
        this.show = true;
        this.urltime = setInterval(() => {
          this.getLogin();
        }, 5000);
      }
    },
    headerShow() {
      if (this.loginTxt != "扫码登陆") {
        this.myfont = "14px";
        //this.isLogin=!this.isLogin;
        this.header = true;
      }
    },

    codeHide() {
      this.iscode = false;
      this.show = false;
      this.showBox = false;
      this.cover = false;
      this.closeLive = false;
      this.mseArr = [];
      clearInterval(this.urltime);
    },
    cutConnect() {
      let _this = this;
      let qs = require("qs");
      let data = qs.stringify({
        roomName: this.roomName,
        userId: this.userid
      });
      $(".rrrr").html("");
      $(".rrrr").html(
        '<div id="id_test_video" style="width:100px; height:100px;background: pink;position: fixed;left: 50%;top: 50%;z-index: 0;"></div>'
      );
      this.$http
        .post("live/setEndSpeak.do", data)
        .then(function (response) {
          console.log(response);
          if (response.status == 200) {
            _this.showLive();

            //_this.mseArr=response.data.data;
            //console.log(_this.mseArr);
            //alert('上传成功');
            //location.reload();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    connect() {
      let _this = this;
      //console.log(this.roomName);
      //return
      let qs = require("qs");
      let data = qs.stringify({
        roomName: this.roomName,
        userId: this.userid
      });
      $(".rrrr").html("");
      $(".rrrr").html(
        '<div id="id_test_video" style="width:100px; height:100px;background: pink;position: fixed;left: 50%;top: 50%;z-index: 0;"></div>'
      );
      //$("#id_test_video").remove();
      //console.log($("#id_test_video"))
      //_this.aaaaa="../../static/tests(2).html?a="+_this.playerUrl;
      //console.log(_this.aaaaa)
      this.$http
        .post("live/setSpeak.do", data)
        .then(function (response) {
          console.log(response.data.data);
          if (navigator.userAgent.indexOf("Window") > 0) {
            _this.playerUrl = response.data.data.rtmpUrl;
            console.log("Windows");
          } else if (navigator.userAgent.indexOf("Mac OS X") > 0) {
            _this.playerUrl = response.data.data.hlsUrl;
            console.log("Mac");
          }

          if (response.status == 200) {
            console.log(_this.playerUrl);
            setTimeout(function pull() {
              let player = new TcPlayer("id_test_video", {
                m3u8: _this.playerUrl,
                autoplay: true,
                coverpic: "",
                width: "100",
                height: "100"
              });
            }, 8000);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    closeL() {
      this.closeLive = true;
      this.cover = true;
    },
    clickIt(value) {
      this.playerUrl = value.hlsUrl;
      //console.log(this.playerUrl);
      this.userid = value.userId;
      if (value.operation == 0) {
        for (let i = 0; i < this.mseArr.length; i++) {
          this.mseArr[i].operation = 0;
        }
        value.operation = 1;
        this.connect();
      } else {
        value.operation = 0;
        this.cutConnect();
      }
      //value.operation = !value.operation
    },
    showLive() {
      this.cover = true;
      this.showBox = true;
      let _this = this;
      //console.log(this.roomName);
      //return
      let qs = require("qs");
      let data = qs.stringify({
        roomName: this.roomName
      });
      _this.mseArr = [];
      this.$http
        .post("live/getActiveUsers.do", data)
        .then(function (response) {
          console.log(response);
          if (response.status == 200) {
            _this.mseArr = response.data.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onCopy(e) {
      alert("复制成功!");
    },
    onError(e) {
      alert("复制失败!");
    },
    getMsg() {
      //return
      let _this = this;
      let qs = require("qs");
      let data = qs.stringify({
        id: this.$route.query.nickNames
      });
      this.$http
        .post("live/openLive.do", data)
        .then(function (response) {
          console.log(response);
          if (response.status == 200) {
            //alert('上传成功');
            //location.reload();
            //			   		if(typeof localStorage.rtmpurl!="undefined"){
            //			   			_this.livecode = localStorage.livecode;
            //				   		_this.rtmpurl = localStorage.rtmpurl;
            //				   		_this.roomName = localStorage.roomName;
            //			   		}else{
            _this.livecode = response.data.data.livecode;
            _this.rtmpurl = response.data.data.rtmpurl;
            _this.roomName = response.data.data.roomName;
            //			   		}
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onlineOr() {
      if (this.open) {
        this.showLive();
        return;
      }
      let _this = this;
      let qs = require("qs");
      let data = qs.stringify({
        roomName: this.roomName,
        operation: 1
      });
      this.$http
        .post("live/setAuthority.do", data)
        .then(function (response) {
          console.log(response);
          if (response.status == 200) {
            _this.close = open;
            _this.forbid = forbid;
            _this.open = true;
            //console.log(_this.id)
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    closed() {
      //	    	this.close = close;
      //	    	this.forbid = forbidOpen;
      let _this = this;
      let qs = require("qs");
      let data = qs.stringify({
        roomName: this.roomName,
        operation: 0
      });
      this.$http
        .post("live/setAuthority.do", data)
        .then(function (response) {
          console.log(response);
          if (response.status == 200) {
            //alert('上传成功');
            //location.reload();
            _this.close = close;
            _this.forbid = forbidOpen;
            _this.open = false;
            //console.log(_this.id)
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getData() {
      console.log(this.title);
      let _this = this;
      this.$http
        .get("live/getLatelyLive.do?userId=" + localStorage.userid)
        .then(function (response) {
          console.log(response);
          if (response.status == 200) {
            //alert('上传成功');
            //location.reload();
            _this.title = response.data.data.live.name;
            _this.time1 = response.data.data.live.starttimeStr;
            _this.stuname = response.data.data.live.stuname;
            _this.text = response.data.data.live.text;
            _this.id = response.data.data.live.id;
            localStorage.time = response.data.data.starttimeStr;
            localStorage.stuname = response.data.data.stuname;
            localStorage.text = response.data.data.text;
            localStorage.title = response.data.data.title;
            //_this.roomName=response.data.data.live.roomName;
            //console.log(_this.id)
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getLogin() {
      console.log(11111);
      let _this = this;
      let qs = require("qs");
      let data = qs.stringify({
        code: _this.code
      });
      this.$http
        .post("checkQRCode.do", data)
        .then(function (response) {
          console.log(response);
          if (response.status == 200) {
            if (response.data.data.token != "") {
              clearInterval(_this.urltime);
              _this.loginTxt = response.data.data.username;
              _this.userimg = response.data.data.img;
              localStorage.username = response.data.data.username;
              localStorage.userimg = response.data.data.img;
              localStorage.userid = response.data.data.userid;
              token = response.data.data.token;
              _this.codeShow();
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCode() {
      let _this = this;
      this.$http
        .get("getQR.do")
        .then(function (response) {
          console.log(response);
          if (response.status == 200) {
            _this.initQCode = response.data.data.code;
            _this.code = response.data.data.code
              .split("code=")[1]
              .split("&")[0];
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.closeBox {
  width: 580px;
  height: 360px;
  z-index: 10;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -290px;
  margin-top: -180px;
  background: #ffffff;
  z-index: 10;
}

.closeBox p {
  text-align: center;
  padding: 20px 0;
}

.closeBox h2 {
  font-size: 24px;
  color: #3296fa;
  text-align: center;
}

.closeBox h3 {
  font-size: 18px;
  color: #666666;
  text-align: center;
  padding: 10px;
}

.closeBox h4 {
  text-align: center;
  padding-top: 60px;
}

.closeBox h4 span {
  display: inline-block;
  background-image: linear-gradient(89deg, #31cdf9 0%, #038cfd 98%);
  box-shadow: 0 4px 10px 0 rgba(0, 128, 254, 0.5);
  border-radius: 8px;
  font-size: 20px;
  color: #ffffff;
  text-align: center;
  width: 150px;
  height: 60px;
  line-height: 60px;
}

/*头像*/
.personageBox {
  height: 254px;
  /*background: pink;*/
  width: 230px;
  position: absolute;
  right: 10px;
  background: #f9f9f9;
  z-index: 6;
}

.personageBox ul {
  float: none;
  margin-left: 0;
}

.personageBox ul li {
  height: 84px;
  font-size: 20px;
  color: #999999;
  text-align: center;
  line-height: 84px;
  border-bottom: 1px solid #ececec;
  float: none;
}

.personageBox ul li:nth-of-type(3) {
  border: none;
}

.scodes img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  vertical-align: middle;
}

/*over*/
/*连麦弹窗*/
.wheatBox {
  width: 920px;
  height: 560px;
  z-index: 10;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -410px;
  margin-top: -280px;
  background: #ffffff;
  z-index: 10;
}

.wheatBox h5 {
  font-size: 24px;
  color: #3296fa;
  text-align: center;
  padding: 20px 0;
}

.wheatBox h5 span {
  font-size: 14px;
  color: #999999;
  float: right;
  font-weight: 500;
  margin-right: 30px;
  margin-top: 10px;
}

.wheatBox h5 span:hover {
  cursor: pointer;
}

.peopleBox {
  width: 860px;
  height: 400px;
  margin: 0 auto;
  overflow-y: scroll;
  padding-top: 20px;
  /*background: pink;*/
}

.peopleBox dl {
  width: 80px;
  height: 150px;
  padding: 0 20px;
  float: left;
  position: relative;
  left: 0;
  top: 0;
}

.peopleBox dl .headpic {
  width: 78px;
  height: 78px;
  border-radius: 50%;
  margin-bottom: 15px;
}

.peopleBox dl dt i {
  position: absolute;
  left: 34%;
  bottom: 50px;
}

.peopleBox dl dd {
  width: 78px;
  text-align: center;
  font-size: 14px;
  color: #999999;
}

.my-trans-enter-active,
.my-trans-leave-active {
  transition: all 0.5s ease-out;
}

.my-trans-enter {
  transform: translateX(-200px);
  opacity: 0;
}

.my-trans-leave-active {
  transform: translateX(1000px);
}

.helpBox {
  /*width: 580px;*/
  /*height: 590px;*/
  position: fixed;
  z-index: 10;
  /*background: #FFFFFF;*/
  left: 72%;
  top: 50%;
  /*margin-left: -290px;*/
  margin-top: -295px;
}

html,
body {
  height: 100%;
  width: 100%;
}

#cower {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 6;
}

.headers {
  border-bottom: 1px solid #ededed;
}

.tipBox {
  width: 580px;
  height: 592px;
  position: fixed;
  z-index: 10;
  background: #ffffff;
  left: 50%;
  top: 50%;
  margin-left: -290px;
  margin-top: -295px;
}

.tipBox h3 {
  width: 100%;
  text-align: center;
  padding: 40px 0 20px 0;
}

.tipBox p {
  font-size: 20px;
  color: #666666;
  text-align: center;
}

.tipBox p img {
  padding-top: 30px;
  width: 280px;
}

.tipBox h6 {
  font-size: 14px;
  padding-top: 20px;
  text-align: center;
}

.tipBox h6 a {
  color: #666666;
  font-weight: 400;
}

header {
  width: 1260px;
  height: 84px;
  margin: 0 auto;
  vertical-align: middle;
  padding-top: 20px;
  position: relative;
}

header img {
  width: 150px;
  height: 60px;
}

.logo {
  float: left;
}

header ul {
  float: left;
  margin-left: 120px;
}

header ul li {
  float: left;
  line-height: 60px;
  padding: 0 40px;
  font-size: 20px;
  color: #666666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

header ul li:hover {
  color: #0075fc;
}

header ul li:nth-of-type(1) a {
  color: #0075fc;
}

.scodes {
  border-radius: 8px;
  width: 130px;
  height: 50px;
  display: inline-block;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  color: #ffffff;
  margin-left: 50px;
  background-image: linear-gradient(270deg, #fca36a 0%, #ec5e45 98%);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

aside {
  width: 1260px;
  margin: 0 auto;
  min-height: 1700px;
  padding-top: 100px;
}

aside .leftBox {
  float: left;
}

aside .leftBox ul li {
  width: 230px;
  height: 84px;
  text-align: center;
  line-height: 84px;
  border: 1px solid #ebebeb;
  font-size: 20px;
}

aside .leftBox ul li a {
  color: #999999;
}

aside .leftBox ul li:nth-of-type(2) a {
  color: #666666;
}

.rightBox {
  width: 1026px;
  min-height: 1600px;
  float: right;
  border: 1px solid #ebebeb;
}

.rightBox dl {
  height: 140px;
  width: 920px;
  margin: 0 auto;
  padding-top: 40px;
}

.rightBox dl dt {
  float: left;
}

.rightBox dl dd {
  float: left;
}

.rightBox dl dd p {
  font-size: 18px;
  color: #666666;
  letter-spacing: -0.53px;
  line-height: 21px;
  padding-left: 30px;
}

.rightBox dl dd p:nth-of-type(1) {
  padding-bottom: 24px;
  padding-top: 24px;
}

.rightBox ul {
  width: 940px;
  padding: 10px 0;
  margin: 0 auto;
  border-bottom: 1px solid #ebebeb;
  border-top: 1px solid #ebebeb;
}

.rightBox ul li {
  padding: 20px 2px;
  position: relative;
}

.rightBox ul li span.coye {
  position: absolute;
  left: 50%;
  background-image: linear-gradient(89deg, #fca36a 0%, #ec5e45 98%);
  border-radius: 2px;
  font-size: 10px;
  color: #ffffff;
  display: block;
  width: 56px;
  top: 94px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.rightBox ul li p {
  font-size: 20px;
  color: #666666;
  padding-bottom: 20px;
}

.rightBox ul li input {
  border: 1px solid #ebebeb;
  width: 410px;
  padding-right: 500px;
  height: 62px;
  padding-left: 10px;
}

.rightBox ul li textarea {
  border: 1px solid #ebebeb;
  width: 910px;
  height: 140px;
  padding-left: 10px;
  padding-top: 10px;
  resize: none;
}

.rightBox .openBt {
  width: 150px;
  height: 60px;
  background-image: linear-gradient(270deg, #31cdf9 0%, #038cfd 98%);
  box-shadow: 0 4px 10px 0 rgba(0, 128, 254, 0.5);
  font-size: 20px;
  color: #ffffff;
  display: inline-block;
  text-align: center;
  line-height: 60px;
  margin-left: 44px;
  margin-right: 10px;
  border-radius: 8px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.jiaocheng {
  font-size: 14px;
  color: #fcba4c;
}

.fottors {
  font-size: 18px;
  color: #999999;
  text-align: center;
  line-height: 84px;
}
</style>



// WEBPACK FOOTER //
// src/pages/OpenedLive.vue